import { defineRouteDef, z } from '@/domains/common/api';

export const subagentSnapshot = z.object({
  id: z.string(),
  name: z.string(),
  model: z.enum(['haiku', 'sonnet', 'opus']),
  status: z.string(),
  goal: z.string(),
  completion_criteria: z.string(),
  tool_allowlist: z.array(z.string()),
  employer_scope: z.enum(['all', 'specific']),
  employer_ids: z.array(z.string()),
  ftw_enabled: z.boolean(),
  result_summary: z.string().nullable(),
  failure_reason: z.string().nullable(),
  max_turns: z.number(),
  max_seconds: z.number(),
  created_at: z.string(),
  started_at: z.string().nullable(),
  ended_at: z.string().nullable(),
});

// JSONB column on subagent_chat_messages — heterogeneous, written by
// subagent-runner. `.catch(null)` keeps unknown future shapes from
// failing the response schema (FE just won't render that action).
export const subagentMessageActions = z
  .discriminatedUnion('kind', [
    z.object({
      kind: z.literal('tool_use'),
      tool_name: z.string(),
      args: z.unknown().optional(),
    }),
    z.object({
      kind: z.literal('report_complete'),
      status: z.string(),
    }),
  ])
  .nullable()
  .catch(null);

export const subagentChatMessage = z.object({
  id: z.string(),
  seq: z.number(),
  role: z.enum(['user', 'agent', 'system', 'matilda']),
  body: z.string(),
  actions: subagentMessageActions,
  created_at: z.string(),
});

export const subagentFtwSessionRef = z.object({
  id: z.string(),
  stage_key: z.string(),
  status: z.string(),
  started_at: z.string(),
});

export const getSubagentRoute = defineRouteDef({
  method: 'GET',
  path: '/api/subagents/[id]',
  audience: 'user',
  params: z.object({ id: z.uuid() }),
  output: z.object({
    agent: subagentSnapshot,
    employer_names: z.array(z.object({ id: z.string(), name: z.string() })),
    messages: z.array(subagentChatMessage),
    active_ftw_session_id: z.string().nullable(),
    ftw_sessions: z.array(subagentFtwSessionRef),
  }),
});
